import React from 'react'
import { Fixed } from '../../bases/Fixed'
import { VStack } from '../../bases/VStack'
import { Text } from '../../bases/Text'
import { PinkNeonButton } from '../../buttons/PinkNeonButton'

export type Props = {
  onClickWait: () => void
  onClickSearch: () => void
}

export const Layout = (props: Props) => {
  return (
    <>
      <Fixed className="left-0 z-[150] h-full w-full items-center overflow-hidden overscroll-contain bg-black bg-opacity-70">
        <style global jsx>{`
          body,
          html {
            overflow: hidden;
          }
        `}</style>
        <VStack className="mx-6 h-fit gap-y-6 rounded-[10px] border border-neon-blue bg-black py-6">
          <Text className="px-2 text-center text-sm font-bold text-[#DC325B]">
            This AM is currently in use by someone else.
          </Text>
          <VStack className="gap-y-6 px-6">
            <PinkNeonButton onClick={props.onClickWait}>
              <Text className="font-semibold text-white">Continue waiting here</Text>
            </PinkNeonButton>
            <PinkNeonButton onClick={props.onClickSearch}>
              <Text className="font-semibold text-white">Look for another AM</Text>
            </PinkNeonButton>
          </VStack>
        </VStack>
      </Fixed>
    </>
  )
}
